<template>
    <section>
      <div class="w-full bg-white rounded-md mt-2 p-4">
        <div class="w-full flex gap-2 items-center">
          <i class="pi pi-list"></i>
          <p class="text-lg font-bold">Listado de IPS</p>
          <Button @click="displayModalIps = true, idIps = null" class="ml-auto rounded-md" label="Crear IPS" />
        </div>
        <div class="grid grid-cold-1 md:grid-cols-2 lg:grid-cols-5 gap-2 my-2">
          <!-- filtro por id -->
          <div class="w-full">
            <label class="text-xs text-gray-600" for="idIps">Id</label>
            <InputText class="w-full" id="idIps" @keyup.enter="listarIps" v-model="filtros.IdIps" />
          </div>
          <!-- filtro por nombre -->
          <div class="w-full">
            <label class="text-xs text-gray-600" for="nombre">Nombre IPS</label>
            <InputText class="w-full" id="nombre" @keyup.enter="listarIps" v-model="filtros.NomIps"/>
          </div>
          <div class="flex gap-2">
            <Button @click="listarIps" class="mt-5 mb-1.5 rounded-md" label="Buscar" />
            <Button @click="limpiarFiltros" class="mt-5 mb-1.5 rounded-md p-button-outlined p-button-secondary" label="Limpiar" />
          </div>
        </div>
        <div class="w-full my-2">
          <DataTable class="p-datatable-sm text-xs" :value="medicos.rows" responsiveLayout="scroll">
            <Column header="Id">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ data.IdIps }}</p>
                  <div class="flex gap-x-4 hover:text-blue-600 text-white transition ease-in-out duration-500">
                    <button class="underline italic" @click='EditIps(data.Id)'>Editar</button>
                  </div>
                </div>
              </template>
            </Column>
            <Column field="NomIps" header="Nombre Ips"></Column>

            <Column header="Acción">
              <template #body="{data}">
                <div class="p-2 rounded-md text-center" >
                  <Button
                      @click='DeleteIps(data.Id)'
                      severity="danger"
                      v-tooltip="'Eliminar'"
                      class='p-button-rounded p-button-icon-only mx-2'
                  >
                    <i class="pi pi-trash text-white"></i>
                  </Button>
                </div>
              </template>
            </Column>
          </DataTable>
          <Paginator v-model:first="offset"
            :rows="limit"
            :totalRecords="parseInt(medicos.count)"
            :rowsPerPageOptions="[2,10,20,30,100]"
            @page="onPage($event)"
          />
        </div>
      </div>
      <Dialog :header="`${idIps ? 'Actualizar' : 'Crear'} Ips`" v-model:visible="displayModalIps" :breakpoints="{'960px': '95vw'}" :style="{width: '60vw'}" :modal="true">
        <div class="grid gap-4 bg-white dark:bg-dark-1 dark:text-gray-500 w-full sm:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 xxl:grid-cols-5">
          <div class="sm:col-span-2 lg:col-span-5 xl:col-span-5 xxl:col-span-5">
            <crearIps @crearIps="displayModalIps = false, listarIps()" :idIps="idIps" />
          </div>
        </div>
      </Dialog>
      <Toast />
    </section>
</template>
<script setup>
  import { useToast } from 'primevue/usetoast'
  import Swal from 'sweetalert2'
  import IpsService from '../../../../../services/ips.service'
  import { onMounted, ref, computed } from 'vue'
  import crearIps from './crear.vue'
    // name: 'ListadoOrdenesVenta'
    // Servicios
    const toast = useToast()
    const _IpsService = ref(new IpsService())
    // Referencias
    const medicos = ref([])
    const MedSeleccionada = ref()
    const limit = ref(10)
    const offset = ref(0)
    const filtros = ref({
      IdIps: null,
      NomMedico: null
    })
    const idIps = ref(null)
    const displayModalIps = ref(false)
    const params = computed(() => {
      return {
        limit: limit.value,
        offset: offset.value,
        ...filtros.value
      }
    })
    // Metodos
    const onPage = ({ first, page, pageCount, rows }) => {
      limit.value = rows
      listarIps(params.value)
    }
    const listarIps = () => {
      const object = {
        ...params.value,
        limit: limit.value,
        offset: offset.value
      }
      _IpsService.value.paginate(object).then(({ data }) => {
        medicos.value = data
      })
    }
    const EditIps = (id) => {
      displayModalIps.value = true
      idIps.value = id
    }
    const DeleteIps = (id) => {
      Swal.fire({
          title: 'Esta seguro de eliminar esta IPS?',
          showDenyButton: true,
          denyButtonText: 'Cancelar',
          confirmButtonText: 'Eliminar'
        }).then((result) => {
          if (result.isConfirmed) {
            _IpsService.value.eliminarIps(id).then(({ data }) => {
              if (data.error) {
                console.error('Error al eliminar la IPS, por favor intente nuevamente')
              } else {
                toast.add({ severity: 'success', summary: 'Exito', detail: 'IPS eliminada exitosamente', life: 3000 })
              }
              listarIps()
            })
          } else if (result.isDenied) {
            Swal.fire('IPS no eliminada', '', 'info')
          }
        })
    }
    const limpiarFiltros = () => {
      filtros.value = {
        IdIps: null,
        NomMedico: null
      }
      MedSeleccionada.value = ''
      listarIps()
    }
    onMounted(() => {
      listarIps()
    })
</script>
<style>
  .p-dropdown-label{
    font-size: 0.75rem !important
  }
  .tipoId .p-dropdown-trigger {
    display: none !important;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(189, 189, 189);
    border-radius: 9999px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  ::-webkit-input-placeholder { /* Edge */
    color: gray;
  }
  ::-webkit-scrollbar {
    width: 0.4rem;
  }
</style>
